// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__b84Uu","modalBody":"StaffClientsModal_modalBody__v7xvU","formControl":"StaffClientsModal_formControl__SztZv"};